import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { defineComponent, onMounted, onBeforeUnmount } from 'vue'
import Layout from '@/components/Layout/index.vue'
import inobounce from 'inobounce'
import { useStore } from 'vuex'
// import wx from 'weixin-js-sdk'
import wxsdk from '@/wxsdk/wxsdk'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore()

onMounted(async () => {
  store.dispatch('common/getWebsiteConfig')
  console.log(store.state.user.token, 8989)
  const localOpenId = localStorage.getItem('wds_openid')

  if (wxsdk.isWechat()) {
    await wxsdk.getWxAuthor()
  }
})

// export default defineComponent({
//   components: {
//     Layout,
//     CartIcon
//   },
//   setup() {
//     onMounted(() => {
//       // inobounce.enable()
//     })
//     onBeforeUnmount(() => {
//       // 防止用户打开弹框时，切换了页面，导致切换的页面无法滚动
//       // 调用 inobounce 对象的 disable()方法，取消禁止滚动条，避免影响内容页的滑动效果
//       // inobounce.disable()
//     })
//   }
// })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Layout))
}
}

})